<template>
  <!--
          作者：gmshop
          时间：2019-10-25
          描述：会员-用户列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户ID"><el-input v-model="formInline.user_id" placeholder="用户ID" style="width:120px"></el-input></el-form-item>
        <el-form-item label="名称或手机"><el-input v-model="formInline.real_name" placeholder="请输入名称或手机" style=""></el-input></el-form-item>
       <!-- <el-form-item label="会员等级">
          <el-select v-model="formInline.grade_id" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="所属单位">
           <el-select v-model="formInline.unit_id" placeholder="请选择" @change="initUnit">
             <el-option label="全部" value="0"></el-option>
             <el-option v-for="(item, index) in unit" :key="index" :label="item.unit_name" :value="item.unit_id"></el-option>
           </el-select>
         </el-form-item>
        <el-form-item label="所属团队" v-if="formInline.unit_id != ''">
           <el-select v-model="formInline.unit_group_id" placeholder="请选择" >
             <el-option label="全部" value="0"></el-option>
             <el-option v-for="(item, index) in group" :key="index" :label="item.unit_group_name" :value="item.unit_group_id"></el-option>
           </el-select>
         </el-form-item>
       <!-- <el-form-item label="团长ID"><el-input v-model="formInline.top_user_id" placeholder="用户ID" style="width:120px"></el-input></el-form-item> -->
        <el-form-item label="注册时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.reg_date" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item>
        <el-form-item><el-button type="primary" @click="openUpload" v-auth="'/user/user/import'">导入</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" @click="onFormat" v-auth="'/user/user/format'">导入模板</el-button></el-form-item>
      </el-form>
    </div>
    <!--添加会员-->
    <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/user/user/add'">添加用户</el-button></div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange">
          <el-table-column prop="user_id" label="ID" width="80" sortable="custom"></el-table-column>
          <!-- <el-table-column prop="nickName" label="昵称"></el-table-column> -->
          <el-table-column prop="nickName" label="用户" width="300">
            <template slot-scope="scope">
              <div class="d-s-c">
               <!-- <img :src="scope.row.avatarUrl" width="60px" height="60px" /> -->
                <div class="ml10">
                  <p class="f14 fb">{{ scope.row.real_name }}<span v-if="scope.row.is_team">(队长)</span> </p>
                  <p class="gray3" v-if="scope.row.mobile">手机：{{ scope.row.mobile }}</p>
                  <p class="gray9">性别：{{ scope.row.gender | convertSex }}</p>
                  <p class="gray9">服装尺码：{{ scope.row.user_height }}</p>
                  <!-- <p class="gray9">身高：{{ scope.row.user_height }}</p>
                  <p class="gray9">体重：{{ scope.row.user_weight }}</p> -->
                  <!-- <p class="gray9" v-if="scope.row.referee_id">推荐人ID：{{ scope.row.referee_id }} {{scope.row.referee}}</p>
                  <p class="gray9" v-if="scope.row.referee_id && scope.row.user_referee!=null">
                    推荐人：{{ scope.row.user_referee.nickName }} [<span class="golden">{{ grade[scope.row.user_referee.grade_id].name }}</span>]

                  </p>
                   <p class="gray9" v-if="scope.row.open_id">
                    小程序OpenID：【{{ scope.row.open_id }}】

                  </p> -->
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="total_points" label="总积分" align="center"></el-table-column>
          <el-table-column prop="points" label="可用积分" align="center"></el-table-column>
          <el-table-column prop="total_step" label="累计步数" align="center"></el-table-column>
          <!-- <el-table-column prop="balance" label="余额" sortable="custom" align="center"></el-table-column>
          <el-table-column prop="invite_code" label="邀请码" sortable="custom" align="center"></el-table-column>
          <el-table-column prop="referees_count" label="直推人数" sortable="custom" align="center">
            <template slot-scope="scope">
              <span @click="gotoPage('/user/structure/index', {user_id:scope.row.user_id})">{{ scope.row.referees_count }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="agent_log_sum" label="佣金" sortable="custom" align="center">
            <template slot-scope="scope">
              <span @click="gotoPage('/user/agent/index', {user_id:scope.row.user_id})">{{ scope.row.agent_log_sum }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="unit.unit_name" label="所属单位"  align="center"></el-table-column>
          <el-table-column prop="group.unit_group_name" label="所属团队" align="center"></el-table-column>
         <!-- <el-table-column prop="province" label="省市">
            <template slot-scope="scope">
              {{ scope.row.province + scope.row.city }}
            </template>
          </el-table-column> -->
          <el-table-column prop="create_time" label="注册时间" width="140" sortable="custom"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="gotoPage('/user/agent/index', {user_id:scope.row.user_id})" type="text" size="small" v-auth="'/user/agent/index'" href="/" target="_blank">佣金明细</el-button>
              <el-button @click="rechargeClick(scope.row)" type="text" size="small" v-auth="'/user/user/recharge'">充值</el-button>
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/user/user/grade'">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/user/user/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!--会员充值-->
    <Recharge v-if="open_add" :open_add="open_add" :form="userModel" :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'add')"></Recharge>

    <!--会员等级-->
    <Grade v-if="open_edit" :open_edit="open_edit" :form="userModel" :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'edit')"></Grade>

    <FileUpload v-if="open_upload" :open_upload="open_upload"  @closeDialog="closeDialogFunc($event, 'upload')"></FileUpload>
  </div>
</template>

<script>
import UserApi from '@/api/user.js';
import Grade from './dialog/Grade.vue';
import Recharge from './dialog/Recharge.vue';
import FileUpload from './dialog/FileUpload';
import qs from 'qs';
export default {
  components: {
    /*编辑组件*/
    Grade,
    Recharge,
    FileUpload
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        nick_name: '',
        grade_id: '',
        user_id: '',
        reg_date: '',
        top_user_id:'',
        unit_group_id:'',
        real_name:''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      /*等级*/
      gradeList: [],
      grade: [],
      open_upload:false,
      unit:[],
      group:[]
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*跳转页面*/
    gotoPage(path, query) {
      this.$router.push({
        path: path,
        query: query
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.sort_name = self.sortName;
      Params.sort_value = self.sortValue;
      UserApi.userlist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.unit = data.data.unit;
          self.gradeList = data.data.grade;
          data.data.grade.forEach((v,i) => {
            self.grade[v.grade_id] = v
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      self.curPage = 1;
      let Params = self.formInline;
      self.getTableList();
    },
    initUnit(e){
      this.formInline.unit_group_id = '';
      this.unit.forEach(item=>{
        if(item.unit_id == e){
          this.group = item.group
        }
      })
      console.log(e)
    },
    /*排序查询*/
    sortChange(e){
      if (e.order && e.order != null){
        this.sortName = e.prop;
        this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
      }else{
        this.sortName = this.sortValue = '';
      }
      this.tableData = [];
      this.getTableList();
    },

    /*打开添加*/
    addClick(item) {
      this.$router.push('/user/user/add');
    },
    /*打开编辑*/
    editClick(row) {
      let self = this;
      let params = row.user_id;
      this.$router.push({
        path: '/user/user/edit',
        // name: 'mallList',
        query: {
          user_id: params
        }
      });
    },
    rechargeClick(item){
      this.userModel = item;
      this.open_add = true;
    },
    /*打开编辑*/
    // editClick(item) {
    //   this.userModel = item;
    //   this.open_edit = true;
    // },
    onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/user.user/export?' + qs.stringify(this.formInline);
    },
    onFormat: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/user.user/format';
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'upload') {
        this.open_upload = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          UserApi.deleteuser(
            {
              user_id: row.user_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，用户删除成功',
                  type: 'success'
                });
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    },
    /*批量导入*/
    openUpload() {
      this.open_upload = true;
    },
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/user/index.vue